<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
  [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
  [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="yearChange($event)"
    [click]="false"
  />
  <app-filters filtros
    [name]="'filtros.region' | translate" 
    [array]="sucursales" [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="selectAllSucursales" 
    (eventClick)="sucursalChange($event)"
  />
  <app-filters filtros
    [name]="'filtros.ind' | translate" 
    [array]="perspectives" [typeFilter]="Filters.PERSPECTIVES"
    [click]="false"
    (eventClick)="perspectiveChange($event)"
  />
  <div borrador class="borradorZona">
    <div class="w3-button w3-dropdown-click iconoBorrarFiltros"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="borrarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
  <div contenido [ngClass]="{'zonaContenido': viewTabla,'zonaContenido2': !viewTabla,}">
    @if(!skeleton){
      @if (viewTabla) {
        <div class="zonaTablaAnexo1">
          <div class="headerTabla">
            <div class="titulo">
              @for (per of perspectives; track per; let t = $index) {
                @if (per.check){
                  <span class="w3-titulo-contenidomenuSC">{{per.name}}</span>
                  <span class="w3-margin-left-contenido">&bull;</span>
                  <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles}}</span>
                  <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles ? '| ' : ''}}{{periodoSelect}}</span>
                }
              }
            </div>
            <div class="menu">
              <mat-icon class="iconoMen" (click)="modal= true">zoom_out_map</mat-icon>
              <mat-icon [matMenuTriggerFor]="menuPrincipal" class="iconoMen">more_vert</mat-icon>
            </div>
          </div>
          <div class="tablaReal w3-scroll">
            @for (per of perspectives; track per; let p =$index) {
              @if (per.check) {
                <table class="w3-table allBordes">
                  <thead>
                    <tr class="w3-table-title">
                      <th class="w3-border-right-balance w3-center enSticky">
                        <mat-icon class="iconoMen" (click)="expandirElements('consolidado')">{{expandAll?'expand_less': 'expand_more'}}</mat-icon>
                      </th>
                      <th class="w3-border-right-balance w3-center enSticky">
                        {{ 'comercial.colocacion.anexo3.tabla'+(p+1)+'T' + 1 | translate }}
                      </th>
                      @if(p===0){
                        <th class="w3-border-right-balance w3-center enSticky">
                          {{ 'comercial.colocacion.anexo3.tabla1T' + 2 | translate }}
                        </th>
                      }
                      @for (head of per.columns; track head; let i = $index) {
                        <th class="w3-border-right-balance w3-center enSticky">
                          {{ 'comercial.colocacion.anexo3.tabla'+(p+1)+'T' + (i+3) | translate }}
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (region of regiones; track $index) {
                      @if (region.visible) {
                        <tr class="w3-table-trtd filaRegion">
                          <td class="borderAllLow marginIzq">
                            <mat-icon class="iconoMen" (click)="expandirElements(region)">{{region.check?'expand_less': 'expand_more'}}</mat-icon>
                          </td>
                          <td class="borderAllLow marginIzq">
                            {{region.description}}
                          </td>
                          @if (p === 0) {
                            <td class="borderAllLow marginDer celdaDerecha">
                              {{region.measures.carteraTotal??null | formaterNumber:2:',':'.'}}
                            </td>
                          }
                          @for (column of per.columns; track $index) {
                            <td class="borderAllLow marginDer celdaDerecha">
                              {{ region.measures[column.field]??null | formaterNumber:decimalesCampo(column.field):',':'.' }}
                              @if(column.field === 'crecimientoP' || column.field === '%Pdc'){
                                %
                              }
                            </td>
                          }
                        </tr>
                        @if (region.check) {
                          @for (sucursal of region.sucursales; track $index) {
                            <tr class="w3-table-trtd">
                              <td class="borderAllLow marginIzq">
                              </td>
                              <td class="borderAllLow marginIzq">
                                {{sucursal.description}}
                              </td>
                              @if (p === 0) {
                                <td class="borderAllLow marginDer celdaDerecha">
                                  {{sucursal.measures.carteraTotal??null | formaterNumber:2:',':'.'}}
                                </td>
                              }
                              @for (column of per.columns; track $index) {
                                <td class="borderAllLow marginDer celdaDerecha">
                                  {{ sucursal.measures[column.field]??null | formaterNumber:decimalesCampo(column.field):',':'.' }}
                                  @if(column.field === 'crecimientoP' || column.field === '%Pdc'){
                                    %
                                  }
                                </td>
                              }
                            </tr>
                          }
                        }
                      }
                    }
                  </tbody>
                </table>
              }
            }
          </div>
        </div>
        <div class="zonaTarjetasAnexo1">
          @for (item of perspectives; track item; let p = $index;) {
            @if (item.check) {
              <app-scroll-container orientation="vertical">
                @for (tarjeta of tarjetas; track tarjeta; let i = $index) {
                  <app-tarjetas
                    [header]="'comercial.colocacion.anexo3.tabla'+(p+1)+'T'+(i+3) | translate"
                    [valueStr]="tarjeta | formaterNumber:decimalesCampo(item.columns[i].field):',':'.'"
                    [siceHeader]="'1.3rem'"
                    [siceValue]="'2rem'"
                    [footer]="periodoSelect"
                    [showIcon]="false"
                    [icon]="''"
                  />
                }
              </app-scroll-container>
            }
          }
        </div>
      }@else {
        <div class="zonaTarjetas2Anexo1">
          <app-scroll-container orientation="horizontal">
            @for (per of perspectives; track per; let p = $index) {
              @if (per.check) {
                @for (tarjeta of tarjetas; track tarjeta; let i = $index) {
                  <app-tarjetas class="tarjeta"
                    [header]="'comercial.colocacion.anexo3.tabla'+(p+1)+'T'+(i+3) | translate"
                    [valueStr]="tarjeta | formaterNumber:decimalesCampo(per.columns[i].field):',':'.'"
                    [siceHeader]="'1.3rem'"
                    [siceValue]="'2rem'"
                    [footer]="periodoSelect"
                    [showIcon]="false"
                    [icon]="''"
                  />
                }
              }
            }
          </app-scroll-container>
        </div>
        <div class="zonaGraficaAnexo1">
          <div class="headerTabla">
            <div class="titulo">
              @for (per of perspectives; track per; let t = $index) {
                @if (per.check){
                  <span class="w3-titulo-contenidomenuSC">{{metricas[metricaIndex]?.name ?? per.name}}</span>
                  <span class="w3-margin-left-contenido">&bull;</span>
                  <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles2}}</span>
                  <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles2 ? '| ' : ''}}{{periodoSelect}}</span>
                }
              }
            </div>
            <div class="menu">
              <mat-icon class="iconoMen" (click)="etiquetasShow=!etiquetasShow">{{etiquetasShow?'label_off':'label'}}</mat-icon>
              <mat-icon class="iconoMen" (click)="modal= true">zoom_out_map</mat-icon>
              <mat-icon [matMenuTriggerFor]="menuPrincipal" class="iconoMen">more_vert</mat-icon>
            </div>
          </div>
          <div class="graficaReal">
            <app-graficador #graficas
              [type]="type"
              [labels]="labels"
              [data]="data"
              [axisX]="''"
              [axisY]="['']"
              [legend]="{ enabled: true, position: 'bottom' }"
              [etiquetas]="etiquetasShow"
              [porcentaje]="true"
              [zona]="1"
            />
          </div>
        </div>
      }
    }@else{
      <div class="zonaTablaAnexo1">
        <app-skeleton-table class="graficaCompleta" [columnas]="8" [filas]="16"/>
      </div>
      <div class="zonaTarjetasAnexo1S">
        @for (item of tarjetasSkeleton; track $index) {
          <app-skeleton-card/>
        }
      </div>
    }
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal" (close)="modal = false" [export]="true"
  [iconoExport]="viewTabla ? 'description' : 'image'" (exportFile)="viewTabla ? exportExcel() : exportImage()">
  <div modal-header>
    @for (per of perspectives; track per; let t = $index) {
      @if (per.check){
        <span class="w3-titulo-contenidomenuSC">{{viewTabla ? per.name : (metricas[metricaIndex]?.name ?? per.name)}}</span>
        <span class="w3-margin-left-contenido w3-titulo-contenidomenuSC">&bull;</span>
        @if(viewTabla){
          <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles2}}</span>
          <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles2 ? '| ' : ''}}{{periodoSelect}}</span>
        }@else{
          <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles}}</span>
          <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles ? '| ' : ''}}{{periodoSelect}}</span>
        }
      }
    }
  </div>
  <div modal-body class="modalAncho">
    @if(viewTabla){
      <div class="tablaReal w3-scroll">
            @for (per of perspectives; track per; let p =$index) {
              @if (per.check) {
                <table class="w3-table allBordes">
                  <thead>
                    <tr class="w3-table-title">
                      <th class="w3-border-right-balance w3-center enSticky">
                        <mat-icon class="iconoMen" (click)="expandirElements('consolidado')">{{expandAll?'expand_less': 'expand_more'}}</mat-icon>
                      </th>
                      <th class="w3-border-right-balance w3-center enSticky">
                        {{ 'comercial.colocacion.anexo3.tabla'+(p+1)+'T' + 1 | translate }}
                      </th>
                      @if(p===0){
                        <th class="w3-border-right-balance w3-center enSticky">
                          {{ 'comercial.colocacion.anexo3.tabla1T' + 2 | translate }}
                        </th>
                      }
                      @for (head of per.columns; track head; let i = $index) {
                        <th class="w3-border-right-balance w3-center enSticky">
                          {{ 'comercial.colocacion.anexo3.tabla'+(p+1)+'T' + (i+3) | translate }}
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (region of regiones; track $index) {
                      @if (region.visible) {
                        <tr class="w3-table-trtd">
                          <td class="borderAllLow marginIzq">
                            <mat-icon class="iconoMen" (click)="region.check=!region.check">{{region.check?'expand_less': 'expand_more'}}</mat-icon>
                          </td>
                          <td class="borderAllLow marginIzq">
                            {{region.description}}
                          </td>
                          @if (p === 0) {
                            <td class="borderAllLow marginDer celdaDerecha">
                              {{region.measures.carteraTotal??null | formaterNumber:2:',':'.'}}
                            </td>
                          }
                          @for (column of per.columns; track $index) {
                            <td class="borderAllLow marginDer celdaDerecha">
                              {{ region.measures[column.field]??null | formaterNumber:decimalesCampo(column.field):',':'.' }}
                            </td>
                          }
                        </tr>
                        @if (region.check) {
                          @for (sucursal of region.sucursales; track $index) {
                            <tr class="w3-table-trtd">
                              <td class="borderAllLow marginIzq">
                              </td>
                              <td class="borderAllLow marginIzq">
                                {{sucursal.description}}
                              </td>
                              @if (p === 0) {
                                <td class="borderAllLow marginDer celdaDerecha">
                                  {{sucursal.measures.carteraTotal??null | formaterNumber:2:',':'.'}}
                                </td>
                              }
                              @for (column of per.columns; track $index) {
                                <td class="borderAllLow marginDer celdaDerecha">
                                  {{ sucursal.measures[column.field]??null | formaterNumber:decimalesCampo(column.field):',':'.' }}
                                </td>
                              }
                            </tr>
                          }
                        }
                      }
                    }
                  </tbody>
                </table>
              }
            }
          </div>
    }@else {
      <div class="modalGraficaOverflow">
        @if(modal){
          <app-graficador
            [type]="type"
            [labels]="labels"
            [data]="data"
            [axisX]="''"
            [axisY]="['']"
            [zona]="2"
            [porcentaje]="true"
            [etiquetas]="etiquetasShow"
            [legend]="{ enabled: true, position: 'bottom' }"
          />
        }
      </div>
    }
  </div>
</app-modal>

<mat-menu class="w3-medium" #menuPrincipal="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="menuGrafica">
    <mat-icon class="iconoGris">insert_chart</mat-icon>
    <span class="opcionMenuIndent">{{'menu.graficas' | translate}}</span>
  </button>
  @if( !viewTabla ){
    <button mat-menu-item [matMenuTriggerFor]="menuMetrica">
      <mat-icon class="iconoGris">analytics</mat-icon>
      <span class="opcionMenuIndent">{{'menu.metrica' | translate}}</span>
    </button>
    <button mat-menu-item (click)="viewTabla= true">
      <mat-icon class="iconoGris">table_chart</mat-icon>
      <span class="opcionMenuIndent">{{'graf.tabla' | translate}}</span>
    </button>
  }
  <mat-divider></mat-divider>
  @if(viewTabla){
    <button mat-menu-item (click)="exportExcel()">
      <mat-icon class="iconoGris">description</mat-icon>
      <span class="opcionMenuIndent">{{'menu.exportar' | translate}}</span>
    </button>
  }@else {
    <button mat-menu-item (click)="exportImage()">
      <mat-icon class="iconoGris">image</mat-icon>
      <span class="opcionMenuIndent">{{'menu.exportar' | translate}}</span>
    </button>
  }
</mat-menu>

<mat-menu class="w3-medium" #menuMetrica="matMenu">
  @for (m of metricas; track m.index) {
    <button mat-menu-item (click)="metricaChange(m.index)" [disabled]="m.index === metricaIndex">
      <span class="opcionMenuIndent">{{m.name}}</span>
    </button>
  }
</mat-menu>

<mat-menu class="w3-medium" #menuGrafica="matMenu">
  <button mat-menu-item (click)="changeGraph(typeGraphic.AREA)" [disabled]="type === typeGraphic.AREA && !viewTabla">
    <mat-icon class="iconoGris">area_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.area' | translate}}</span>
  </button>
  <button mat-menu-item (click)="changeGraph(typeGraphic.BAR)" [disabled]="type === typeGraphic.BAR && !viewTabla">
    <mat-icon class="iconoGris">bar_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.barras' | translate}}</span>
  </button>
  <button mat-menu-item (click)="changeGraph(typeGraphic.LINE)" [disabled]="type === typeGraphic.LINE && !viewTabla">
    <mat-icon class="iconoGris">show_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.lineal' | translate}}</span>
  </button>
</mat-menu>